<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : deliveryBills.pkid > 0 ? '编辑' : '新建'"
      width="1200px"
      top="10px"
      class="outStockBillsEdit"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="deliveryBills"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="deliveryBills.pkid > 0" :span="12">
          <el-form-item label="出库单号" prop="billNo">
            <el-input v-model="deliveryBills.billNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户" prop="customerName">
            <el-input v-model="deliveryBills.customerName" disabled/>
          </el-form-item>
        </el-col>
<!--        <el-col :span="12">-->
<!--          <el-form-item label="需求时间" prop="requireDate">-->
<!--            <el-input v-model="deliveryBills.requireDate" disabled/>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="12">
          <el-form-item label="发货联系人" prop="deliveryContact">
            <el-input v-model="deliveryBills.deliveryContact"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发货联系方式" prop="deliveryTel">
            <el-input v-model="deliveryBills.deliveryTel"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="发货地址" prop="deliveryAddress">
            <el-input v-model="deliveryBills.deliveryAddress"/>
          </el-form-item>
        </el-col>
        <el-col v-if="deliveryBills.pkid > 0" :span="12">
          <el-form-item label="制单日期" prop="createDate">
            <el-input v-model="deliveryBills.createDate" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="deliveryBills.pkid > 0" :span="12">
          <el-form-item label="制单人" prop="billUserName">
            <el-input v-model="deliveryBills.billUserName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="note">
            <el-input v-model="deliveryBills.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle" style="margin-top: 10px">出库明细</div>
      <div style="text-align: right;">
        <!--        <el-button v-if="!disabled" type="primary" @click="$refs.BatchFLlocationSelect.open()">批量更新仓位</el-button>-->
        <el-button
            v-if="!disabled"
            type="primary"
            style="margin-bottom: 10px;margin-right: 10px;"
            @click="$refs.deliveryNoticeSelect.open()">
          添加
        </el-button>
        <delivery-notice-detail-select ref="deliveryNoticeSelect" @select="deliveryNoticeSelect"/>
        <!--        <warehouse-location-select ref="BatchFLlocationSelect" @select="BatchFLlocationSelect"/>-->
      </div>
      <el-table
          class="tableBox"
          :data="deliveryBills.detailVOS"
          border
          stripe
          height="40vh">
        <el-table-column prop="orderNo" align="left" label="销售订单" width="120"/>
        <el-table-column prop="materialNo" align="left" label="物料编号" width="120"/>
        <el-table-column prop="materialName" align="left" label="物料名称" width="120"/>
        <el-table-column prop="specification" align="center" label="规格型号"/>
        <el-table-column align="center" label="要求交期" width="140" prop="deliveryDate"/>
        <el-table-column prop="locationName" align="center" label="出库仓" width="100"/>
<!--        <el-table-column prop="locationName" align="center" label="出库仓" width="230">-->
<!--          <template slot-scope="scope">-->
<!--            <el-input v-model="scope.row.locationName" readonly placeholder="请选择出库仓">-->
<!--              <el-button-->
<!--                  slot="append"-->
<!--                  icon="el-icon-search"-->
<!--                  @click="$refs.FLlocationSelect.open();setIndex(scope.$index)"/>-->
<!--            </el-input>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="quantity" align="center" label="数量" width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="note"
            align="center"
            label="备注"
            width="200"
            show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="scope.row.note" type="textarea" autosize placeholder="请输入"/>
          </template>
        </el-table-column>
<!--        <el-table-column label="操作" align="center" width="80">-->
<!--          <template v-slot="scope">-->
<!--            <el-button type="danger" @click="deleteRow(scope.row,scope.$index)">删除</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
      <warehouse-location-select ref="FLlocationSelect" @select="FLlocationSelect"/>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
<!--      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>-->
    </span>
  </el-dialog>
</template>

<script>
  import WarehouseLocationSelect from "@/views/information/WarehouseLocation/WarehouseLocationSelect";
  import DeliveryNoticeDetailSelect from "@/views/SalesManage/DeliveryNotice/DeliveryNoticeDetailSelect";

  export default {
    name: "MmDeliveryEdit",
    components: {DeliveryNoticeDetailSelect, WarehouseLocationSelect},
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        index: 0,
        deliveryBills: {
          pkid: 0,
          billNo: "",
          relBillNo: "",
          relBillId: "",
          requireDate: "",
          status: "",
          statusName: "",
          creatorName: "",
          createTime: "",
          note: "",
          detailVOS: [],
        },
        ruleValidate: {
          quantity: {required: true, trigger: "blur"},
          relBillNo: {required: true, message: "请选择关联单号", trigger: "change"},
        },
      };
    },
    methods: {
      open(id, disabled) {
        this.dialogVisible = true;
        if (id) {
          this.deliveryBills.pkid = id;
          this.getData();
        }
        if (disabled) {
          this.disabled = true;
        }
      },

      // 根据出货订单id查询详细信息
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `mm/deliveryBills/${this.deliveryBills.pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.deliveryBills = Object.assign(this.deliveryBills, resp.data);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      setIndex(index) {
        this.index = index;
      },

      FLlocationSelect(row) {
        console.log(this.deliveryBills);
        this.deliveryBills.detailVOS[this.index].locationName = row.warehouseLocationName;
        this.deliveryBills.detailVOS[this.index].locationId = row.pkId;
        this.deliveryBills.detailVOS[this.index].locationNo = row.warehouseLocationNo;
        this.deliveryBills.detailVOS[this.index].warehouseAreaName = row.warehouseAreaName;
        this.deliveryBills.detailVOS[this.index].warehouseAreaNo = row.warehouseAreaNo;
        console.log(this.deliveryBills.detailVOS);
      },

      deleteRow(row, index) {
        this.deliveryBills.detailVOS.splice(index, 1);
      },

      //选择关联单号
      deliveryNoticeSelect(rows) {
        if (rows) {
          let custId = rows[0].customerId;
          rows.forEach(item => {
            if (custId !== item.customerId) {
              this.$confirm("请选择相同客户发货通知单", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
          });
          if (this.deliveryBills.pkid === 0) {
            this.deliveryBills.customerId = custId;
            this.deliveryBills.customerNo = rows[0].customerNo;
            this.deliveryBills.customerOutNo = rows[0].customerOutNo;
            this.deliveryBills.customerName = rows[0].customerName;
            this.deliveryBills.customerOuterNo = rows[0].customerOuterNo;
            this.deliveryBills.erpSalType = rows[0].erpSalType;
            this.deliveryBills.erpWorkShop = rows[0].erpWorkShop;
            this.deliveryBills.RequireDate = rows[0].deliveryDate;
            this.deliveryBills.deliveryContact = rows[0].deliveryContact;
            this.deliveryBills.deliveryTel = rows[0].deliveryTel;
            this.deliveryBills.deliveryAddress = rows[0].deliveryAddress;
          }

          rows.forEach(item => {
            if (item.quantity > item.deliveryQuantity) {
              let data = {
                materialNo: item.materialNo,
                materialName: item.materialName,
                specification: item.specification,
                quantity: item.quantity - item.deliveryQuantity,
                deliveryDate: item.requireDeliveryDate,
                note: item.note,
                refBillId: item.masterId,
                refBillNo: item.billNo,
                refRowIndex: item.rowIndex,
                rowIndex: this.rowIndex++,
                locationName: item.locationName,
                locationId: item.locationId,
                warehouseAreaNo: item.warehouseAreaNo,
                warehouseAreaName: item.warehouseAreaName,
              };
              this.deliveryBills.detailVOS.push(data);
            }
          });
        }
      },

      getDetailData(id) {
        this.$http.get("basic", `outStockDeliverys/getDetailByTask/${id}`).then((res) => {
          if (res.success) {
            this.deliveryBills.detailVOS = res.data;
          }
        });
      },
      // // 编辑、新建
      // handleSubmit() {
      //   this.$refs.form.validate((valid) => {
      //     if (valid) {
      //       if (!this.deliveryBills.outStockBillDetailVOS.length) {
      //         this.$confirm("请添加出库明细", "错误", {
      //           type: "error",
      //           showCancelButton: false,
      //         });
      //         return;
      //       }
      //       let flag = false;
      //       this.deliveryBills.outStockBillDetailVOS.forEach(item => {
      //         if (!item.locationName) {
      //           flag = true;
      //         }
      //       });
      //       if (flag) {
      //         this.$confirm("请选择出库仓", "错误", {
      //           type: "error",
      //           showCancelButton: false,
      //         });
      //         return;
      //       }
      //       this.submitLoading = true;
      //       this.$http
      //         .save("basic", "outStockDeliverys", this.deliveryBills)
      //         .then((resp) => {
      //           this.submitLoading = false;
      //           if (resp.success) {
      //             if (this.deliveryBills.pkid > 0) {
      //               this.$emit("save-success");
      //               this.$message.success("编辑成功");
      //             } else {
      //               this.$emit("save-success");
      //               this.$message.success("添加成功");
      //             }
      //             this.dialogVisible = false;
      //           }
      //         })
      //         .catch(() => {
      //           this.submitLoading = false;
      //         });
      //     }
      //   });
      // },

    },
  };
</script>

<style lang="scss" scoped>
.outStockBillsEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.outStockBillsEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.outStockBillsEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.outStockBillsEdit .el-divider--horizontal {
  margin: 10px 0;
}

.outStockBillsEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.tableBox .el-form-item__content {
  margin-left: 0 !important;
}

.tableBox .el-form-item {
  margin-bottom: 0;
}

.tableBox .el-input--mini .el-input__inner {
  text-align: center;
}
</style>
